"use client";

import { FlatAspect } from "@/models/HomePageSearchResponse";
import { Box, Typography } from "@mui/material";
import Link from "next/link";
import { useState } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function OptionsLinkSection({
  title,
  options,
}: {
  title: string;
  options: FlatAspect[];
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        flex: 1,
        gap: 2,
        a: {
          ...theme.typography.body1,
          "&:hover": {
            textDecoration: "underline",
          },
        },
      })}
    >
      <Typography variant="h5" component="h2">{title}</Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          rowGap: 1,
          columnGap: 2,
          maxHeight: isExpanded ? "none" : "60px",
          overflow: "hidden",
        }}
      >
        {options.map((option) => (
          <Link key={option.slug} href={"/for-sale/horses/" + option.slug}>
            {option.label}
          </Link>
        ))}
      </Box>
      {!isExpanded && (
        <Typography
          onClick={() => setIsExpanded(true)}
          sx={{
            alignSelf: "flex-end",
            display: "flex",
            gap: 1,
            cursor: "pointer",
            alignItems: 'center',
            '&:hover': {
              textDecoration: 'underline',
            }

          }}
        >
          Show All <ExpandMoreIcon />
        </Typography>
      )}
    </Box>
  );
}
